import React from "react";

interface IPlanOfferings {
  children: any;
}

export default function PlanOfferings({ children }: IPlanOfferings) {
  return (
    <ul
      css={{
        display: "grid",
        gridRowGap: 5,
        margin: 0,
        padding: 0,
        fontSize: 14,
        listStyle: "none",

        "& > li > strong": {
          fontWeight: 600,
        },
      }}
    >
      {children}
    </ul>
  );
}
